"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentalFeatures = void 0;
/**
 * Experimental feature flags
 */
var ExperimentalFeatures;
(function (ExperimentalFeatures) {
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["NewIndentation"] = "NewIndentation";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["NewBullet"] = "NewBullet";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["NewNumbering"] = "NewNumbering";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["ListChain"] = "ListChain";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["MergePastedLine"] = "MergePastedLine";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["SingleDirectionResize"] = "SingleDirectionResize";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["PasteWithLinkPreview"] = "PasteWithLinkPreview";
    /**
     * @deprecated This feature is always enabled
     */
    ExperimentalFeatures["ImageRotate"] = "ImageRotate";
    /**
     * Crop an inline image (requires ImageEdit plugin)
     */
    ExperimentalFeatures["ImageCrop"] = "ImageCrop";
    /**
     * @deprecated This feature is always enabled
     * Check if the element has a style attribute, if not, apply the default format
     */
    ExperimentalFeatures["AlwaysApplyDefaultFormat"] = "AlwaysApplyDefaultFormat";
    /**
     * Paste the Html instead of the Img when the Html Body only have one IMG Child node
     */
    ExperimentalFeatures["ConvertSingleImageBody"] = "ConvertSingleImageBody";
    /**
     * Align table elements to left, center and right using setAlignment API
     */
    ExperimentalFeatures["TableAlignment"] = "TableAlignment";
    /**
     * Provide additional Tab Key Features. Requires Text Features Content Editable Features
     */
    ExperimentalFeatures["TabKeyTextFeatures"] = "TabKeyTextFeatures";
    /**
     * Provide a circular resize handles that adaptive the number od handles to the size of the image
     */
    ExperimentalFeatures["AdaptiveHandlesResizer"] = "AdaptiveHandlesResizer";
    /**
     * Align list elements elements to left, center and right using setAlignment API
     */
    ExperimentalFeatures["ListItemAlignment"] = "ListItemAlignment";
    /**
     * Trigger formatting by a especial characters. Ex: (A), 1. i).
     */
    ExperimentalFeatures["AutoFormatList"] = "AutoFormatList";
    /**
     * @deprecated this feature is always disabled
     * Automatically transform -- into hyphen, if typed between two words.
     */
    ExperimentalFeatures["AutoHyphen"] = "AutoHyphen";
    /**
     * Use pending format strategy to do style based format, e.g. Font size, Color.
     * With this feature enabled, we don't need to insert temp ZeroWidthSpace character to hold pending format
     * when selection is collapsed. Instead, we will hold the pending format in memory and only apply it when type something
     */
    ExperimentalFeatures["PendingStyleBasedFormat"] = "PendingStyleBasedFormat";
    /**
     * Normalize list to make sure it can be displayed correctly in other client
     * e.g. We will move list items with "display: block" into previous list item and change tag to be DIV
     */
    ExperimentalFeatures["NormalizeList"] = "NormalizeList";
})(ExperimentalFeatures = exports.ExperimentalFeatures || (exports.ExperimentalFeatures = {}));
//# sourceMappingURL=ExperimentalFeatures.js.map